// Mock data for AiFlo.ai website

export const services = [
  {
    id: 1,
    title: "AI & Automation",
    description: "Transform your enterprise with intelligent automation and AI-driven solutions that amplify human potential.",
    icon: "Bot",
    features: ["AI-Augmented Consultants", "Intelligent Process Automation", "Machine Learning Integration", "Predictive Analytics"]
  },
  {
    id: 2,
    title: "No-Code/Low-Code Solutions",
    description: "Accelerate development with modern no-code platforms enabling rapid digital transformation.",
    icon: "Blocks",
    features: ["Platform Selection", "Rapid Application Development", "Custom Workflows", "Integration Services"]
  },
  {
    id: 3,
    title: "Data & Analytics",
    description: "Turn data into actionable insights with advanced analytics and comprehensive data management.",
    icon: "Database",
    features: ["Data Engineering", "Business Intelligence", "Data Governance", "Real-time Analytics"]
  },
  {
    id: 4,
    title: "Cloud & Infrastructure",
    description: "Modernize your infrastructure with scalable, secure cloud solutions built for enterprise scale.",
    icon: "Cloud",
    features: ["Cloud Migration", "Multi-Cloud Strategy", "Infrastructure Optimization", "DevOps Implementation"]
  },
  {
    id: 5,
    title: "Enterprise Integration",
    description: "Connect disconnected systems into one intelligent organism with seamless integration solutions.",
    icon: "Network",
    features: ["API Development", "System Integration", "Legacy Modernization", "Middleware Solutions"]
  },
  {
    id: 6,
    title: "Enterprise Applications",
    description: "Implement and optimize enterprise software including ERP, CRM, and industry-specific solutions.",
    icon: "Layers",
    features: ["ERP Implementation", "CRM Solutions", "Custom Applications", "Application Management"]
  }
];

export const caseStudies = [
  {
    id: 1,
    title: "Global Manufacturing Digital Transformation",
    client: "Fortune 500 Manufacturing Company",
    industry: "Manufacturing",
    challenge: "Legacy systems causing operational inefficiencies and data silos across 15 global facilities.",
    solution: "Implemented AI-powered integration platform connecting ERP, MES, and IoT systems with real-time analytics.",
    results: ["40% reduction in operational costs", "60% faster decision-making", "99.9% system uptime"],
    image: "manufacturing"
  },
  {
    id: 2,
    title: "Financial Services Cloud Migration",
    client: "Leading Financial Institution",
    industry: "Financial Services",
    challenge: "Need to modernize infrastructure while maintaining regulatory compliance and zero downtime.",
    solution: "Executed phased cloud migration with AI-driven security monitoring and automated compliance checks.",
    results: ["50% reduction in infrastructure costs", "3x improved scalability", "Zero security incidents"],
    image: "finance"
  },
  {
    id: 3,
    title: "Retail Omnichannel Integration",
    client: "Multi-Brand Retail Group",
    industry: "Retail",
    challenge: "Fragmented customer experience across online and offline channels with disconnected inventory.",
    solution: "Built unified commerce platform using low-code tools integrating POS, e-commerce, and inventory systems.",
    results: ["85% improvement in customer satisfaction", "30% increase in sales", "Real-time inventory accuracy"],
    image: "retail"
  }
];

export const industries = [
  {
    id: 1,
    name: "Manufacturing",
    icon: "Factory",
    description: "Smart manufacturing solutions for Industry 4.0 transformation"
  },
  {
    id: 2,
    name: "Financial Services",
    icon: "TrendingUp",
    description: "Secure, compliant solutions for banking and insurance"
  },
  {
    id: 3,
    name: "Retail & E-commerce",
    icon: "ShoppingCart",
    description: "Omnichannel solutions for modern retail experiences"
  },
  {
    id: 4,
    name: "Healthcare",
    icon: "Heart",
    description: "Digital health solutions improving patient outcomes"
  },
  {
    id: 5,
    name: "Logistics",
    icon: "Truck",
    description: "Supply chain optimization and intelligent logistics"
  },
  {
    id: 6,
    name: "Government",
    icon: "Building2",
    description: "Public sector modernization and citizen services"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "The Future of Enterprise AI: Beyond Automation",
    excerpt: "Exploring how AI is evolving from simple automation to intelligent decision-making partners in enterprise environments.",
    author: "Dr. Priya Sharma",
    date: "2025-01-15",
    category: "AI & Innovation",
    readTime: "8 min read",
    image: "ai-future"
  },
  {
    id: 2,
    title: "No-Code Revolution: Democratizing Enterprise Software",
    excerpt: "How no-code platforms are enabling business users to build sophisticated applications without traditional development.",
    author: "Michael Chen",
    date: "2025-01-10",
    category: "Low-Code/No-Code",
    readTime: "6 min read",
    image: "nocode"
  },
  {
    id: 3,
    title: "Integration Architecture for 2030: A Vision",
    excerpt: "The future of enterprise integration: AI-driven, self-healing systems that adapt to business needs in real-time.",
    author: "Sarah Johnson",
    date: "2025-01-05",
    category: "Integration",
    readTime: "10 min read",
    image: "integration"
  },
  {
    id: 4,
    title: "Cloud-Native Transformation: Lessons from the Field",
    excerpt: "Real-world insights from migrating complex enterprise workloads to cloud-native architectures.",
    author: "Rajesh Kumar",
    date: "2024-12-28",
    category: "Cloud",
    readTime: "7 min read",
    image: "cloud"
  }
];

export const partners = [
  { name: "SAP", logo: "sap" },
  { name: "Oracle", logo: "oracle" },
  { name: "Salesforce", logo: "salesforce" },
  { name: "NetSuite", logo: "netsuite" },
  { name: "Microsoft", logo: "microsoft" },
  { name: "ServiceNow", logo: "servicenow" },
  { name: "Workday", logo: "workday" },
  { name: "AWS", logo: "aws" }
];

export const lowCodePartners = [
  { name: "OutSystems", logo: "outsystems" },
  { name: "Mendix", logo: "mendix" },
  { name: "Power Apps", logo: "powerapps" },
  { name: "Appian", logo: "appian" },
  { name: "Bubble", logo: "bubble" },
  { name: "Retool", logo: "retool" }
];

export const testimonials = [
  {
    id: 1,
    name: "James Anderson",
    position: "CTO",
    company: "Global Manufacturing Corp",
    content: "AiFlo.ai transformed our fragmented systems into a unified, intelligent platform. Their AI-first approach delivered results beyond our expectations.",
    rating: 5
  },
  {
    id: 2,
    name: "Maria Rodriguez",
    position: "VP of Digital Transformation",
    company: "Regional Bank Group",
    content: "Finally, a partner who understands both technology and business outcomes. Their single accountability model eliminated the vendor management nightmare.",
    rating: 5
  },
  {
    id: 3,
    name: "David Kim",
    position: "Head of IT",
    company: "E-commerce Platform",
    content: "The speed of delivery with their AI-augmented approach is remarkable. What would take months with traditional consulting took weeks with AiFlo.ai.",
    rating: 5
  }
];

export const workflowSteps = [
  {
    step: 1,
    title: "Discovery & Strategy",
    description: "AI-powered analysis of your enterprise ecosystem to identify opportunities and design optimal solutions.",
    duration: "2-4 weeks"
  },
  {
    step: 2,
    title: "Architecture & Planning",
    description: "Create comprehensive technical architecture and implementation roadmap with clear milestones.",
    duration: "2-3 weeks"
  },
  {
    step: 3,
    title: "Implementation & Integration",
    description: "Agile development with AI-augmented delivery, continuous integration, and real-time monitoring.",
    duration: "8-16 weeks"
  },
  {
    step: 4,
    title: "Testing & Optimization",
    description: "Rigorous testing, performance optimization, and fine-tuning for production readiness.",
    duration: "2-4 weeks"
  },
  {
    step: 5,
    title: "Deployment & Support",
    description: "Seamless go-live with ongoing managed services and continuous improvement.",
    duration: "Ongoing"
  }
];

export const stats = [
  { label: "Enterprise Clients", value: "150+", icon: "Building2" },
  { label: "Projects Delivered", value: "500+", icon: "Rocket" },
  { label: "Countries Served", value: "25+", icon: "Globe" },
  { label: "Expert Consultants", value: "200+", icon: "Users" }
];

export const chatMessages = [
  {
    id: 1,
    role: "assistant",
    content: "Hello! I'm your AiFlo.ai assistant. How can I help you today?",
    timestamp: new Date()
  }
];
